import React, { useEffect, useState } from "react";
import { Card, Form, Input, message } from "antd";
import IndexList from "./IndexList";
import { getIndexList } from "../../IndexManagement/api";

type SelectIndexProps = {
  onAdd: (content: string) => void;
};

const SelectIndex: React.FC<SelectIndexProps> = ({ onAdd }) => {
  const [form] = Form.useForm();
  const [list, setList] = useState<
    { name: string; children: { name: string }[] }[]
  >([]);

  const onFilter = () => {
    const values = form.getFieldsValue();
    getIndexList({ ...values })
      .then((res) => {
        const parsed = res.map((item) => {
          return {
            name: item.directoryName,
            children: item.indicators.map((ind) => ({
              name: ind.name,
            })),
          };
        });
        setList(parsed);
      })
      .catch((e) => message.error("查询失败" + e.toString()));
  };

  useEffect(() => {
    onFilter();
  }, []);

  return (
    <Card title="我的订阅指标" style={{ width: "100%" }}>
      <Form form={form} onValuesChange={onFilter}>
        <Form.Item name="name" wrapperCol={{ span: 12 }}>
          <Input.Search placeholder="请输入指标名称" />
        </Form.Item>
      </Form>
      <IndexList list={list} onAdd={onAdd}></IndexList>
    </Card>
  );
};

export default SelectIndex;
